<template>
    <div class="login-wrap">
        <div class="ms-login">
            <div class="ms-title"><span>由度</span>后台管理系统</div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm"
                     @keyup.enter.native="submitForm('ruleForm')"
                     label-width="0px" class="ms-content">
                <el-form-item prop="username">
                    <el-input v-model="ruleForm.username" placeholder="用户名">
                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" placeholder="密码" v-model="ruleForm.password">
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="checking" class="checking">
                    <el-input v-model="ruleForm.checking" style="width: 200px" placeholder="验证码">
                    </el-input>
                    <div class="canvas" @click="createVerify()">
                        <canvas id="canvas" ref="canvas" :width="width" :height="height"></canvas>
                    </div>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {setCookie} from '@/utils/cookie';
    import {SysMenu} from "../../api/sysMenu";

    export default {
        data: function () {
            let validateChecking = (rule, value, callback) => {
                if (value.toLowerCase() !== this.verifyCode) {
                    callback(new Error('验证码错误，请重新输入！'))
                } else {
                    callback()
                }
            };
            return {
                width: '100',
                height: '40',
                verifyCode: '',
                city: '',
                ip: '',
                lastLoginTime: '',
                ruleForm: {
                    username: '',
                    password: '',
                    checking: ''
                },
                rules: {
                    username: [
                        {required: true, message: '请输入用户名', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ],
                    checking: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                        {validator: validateChecking, trigger: 'blur'}
                    ]
                },
                context: {}
            }
        },
        created() {
            this.getCt();
            console.log(returnCitySN["cip"]);
            this.getUserIP((ip) => {
                this.ip = ip;
                console.log(this.ip)
            });
        },
        mounted() {
            this.createVerify();
        },
        methods: {
            getUserIP(onNewIP) {
                let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
                let pc = new MyPeerConnection({
                    iceServers: []
                });
                let noop = () => {
                };
                let localIPs = {};
                let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
                let iterateIP = (ip) => {
                    if (!localIPs[ip]) onNewIP(ip);
                    localIPs[ip] = true;
                };
                pc.createDataChannel('');
                pc.createOffer().then((sdp) => {
                    sdp.sdp.split('\n').forEach(function (line) {
                        if (line.indexOf('candidate') < 0) return;
                        line.match(ipRegex).forEach(iterateIP);
                    });
                    pc.setLocalDescription(sdp, noop, noop);
                }).catch((reason) => {
                });
                pc.onicecandidate = (ice) => {
                    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
                    ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
                };
            },

            getCt() {
                let myCity = new BMap.LocalCity();
                myCity.get(res => {
                    this.city = res.name;
                    console.log(this.city)
                });
            },

            /**
             * 获取当前城市
             **/
            // getCurrentCity() {
            //     let geolocation = new qq.maps.Geolocation('AB6BZ-OREKW-UV5RC-R6CXM-BOKAO-OEFL3', 'vue-后台');
            //     let options = {timeout: 5000};
            //     geolocation.getIpLocation(position => {
            //         //console.log(position);
            //         if (position) {
            //             if (position.type === 'h5') {
            //                 this.getCurrentCity();
            //             } else {
            //                 this.city = position.city;
            //             }
            //         }
            //     }, err => {
            //         //console.log('定位失败');
            //         this.getCurrentCity();
            //     }, options)
            // },
            /**
             * 动态验证码
             **/
            createVerify() {
                let canvas_width = this.width;
                let canvas_height = this.height;
                let canvas = this.$refs.canvas;//获取到canvas的对象，演员
                let context = canvas.getContext("2d");//获取到canvas画图的环境，演员表演的舞台
                canvas.width = canvas_width;
                canvas.height = canvas_height;
                let sCode = "a,b,c,d,e,f,g,h,i,j,k,m,n,p,q,r,s,t,u,v,w,x,y,z,A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0";
                let aCode = sCode.split(",");
                let aLength = aCode.length;//获取到数组的长度
                let verifyCode = [];
                for (let i = 0; i < 4; i++) { //这里的for循环可以控制验证码位数（如果想显示6位数，4改成6即可）
                    let j = Math.floor(Math.random() * aLength);//获取到随机的索引值
                    // var deg = Math.random() * 30 * Math.PI / 180;//产生0~30之间的随机弧度
                    let deg = Math.random() - 0.5; //产生一个随机弧度
                    let txt = aCode[j];//得到随机的一个内容
                    verifyCode[i] = txt.toLowerCase();
                    let x = 10 + i * 20;//文字在canvas上的x坐标
                    let y = 20 + Math.random() * 8;//文字在canvas上的y坐标
                    context.font = "bold 23px 微软雅黑";
                    context.translate(x, y);
                    context.rotate(deg);
                    context.fillStyle = this.randomColor();
                    context.fillText(txt, 0, 0);
                    context.rotate(-deg);
                    context.translate(-x, -y);
                }
                for (let i = 0; i <= 5; i++) { //验证码上显示线条
                    context.strokeStyle = this.randomColor();
                    context.beginPath();
                    context.moveTo(Math.random() * canvas_width, Math.random() * canvas_height);
                    context.lineTo(Math.random() * canvas_width, Math.random() * canvas_height);
                    context.stroke();
                }
                for (let i = 0; i <= 30; i++) { //验证码上显示小点
                    context.strokeStyle = this.randomColor();
                    context.beginPath();
                    let x = Math.random() * canvas_width;
                    let y = Math.random() * canvas_height;
                    context.moveTo(x, y);
                    context.lineTo(x + 1, y + 1);
                    context.stroke();
                }
                this.verifyCode = verifyCode.join("");
            },
            //得到随机的颜色值
            randomColor() {
                let r = Math.floor(Math.random() * 256);
                let g = Math.floor(Math.random() * 256);
                let b = Math.floor(Math.random() * 256);
                return "rgb(" + r + "," + g + "," + b + ")";
            },

            //登录
            submitForm(formName) {
                //console.log(this.city);
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url: '/sys/user/login',
                            method: 'post',
                            data: {
                                'username': this.ruleForm.username,
                                'password': this.ruleForm.password
                            }
                        }).then(resp => {
                            if (resp.data && resp.data.code === 0) {
                                let user = resp.data.user;
                                setCookie('user', user, 5);
                                this.saveLoginLog();
                                // 获取菜单路由
                                this.getItems(resp.data.user);
                                // this.$router.replace('/');
                                // this.$options.router = routers;
                            } else {
                                this.$message.error(resp.data.msg)
                            }
                        }).catch(resp => {
                            console.log('请求失败：' + resp.status + ',' + resp.statusText);
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

            /**
             * 获取菜单
             **/
            getItems(user) {
                let rid = user.rid;
                let params = {
                    'rids': rid
                };
                let getMenus = SysMenu.getMenus(params);
                let getMrList = SysMenu.getMrList(params);
                Promise.all([getMenus, getMrList]).then(res => {
                    if (res[0].code === 0 && res[1].code === 0) {
                        let menuList = res[0].menus;
                        let permissions = this.getRoleAuth(res[1].smrList.permissions);
                        localStorage.setItem("menus", JSON.stringify(menuList));
                        localStorage.setItem("permissions", JSON.stringify(permissions));
                        this.$router.go(0);
                    }
                }).catch(res => {
                    console.log(res);
                });
            },

            getRoleAuth(permissions) {
                let auth = [];
                for (let i = 0; i < permissions.length; i++) {
                    auth.push(permissions[i].addPower);
                    auth.push(permissions[i].editPower);
                    auth.push(permissions[i].deletePower);
                }
                return auth;
            },

            /**
             * 保存登录信息
             */
            saveLoginLog() {
                this.$http({
                    url: '/sys/login/log/save',
                    method: 'post',
                    data: {
                        'sysUserId': JSON.parse(localStorage.user).id,
                        'loginAddress': this.city,
                        'addTime': this.lastTime(new Date())
                    }
                })
            },
            lastTime(time) {
                let date = new Date(time);
                let y = date.getFullYear();
                let m = date.getMonth() + 1 >= 10 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
                let d = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();

                let hh = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
                let mm = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
                let ss = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds();
                return y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ':' + ss;
            }
        }
    }
</script>

<style scoped>
    .login-wrap {
        position: relative;
        width: 100%;
        height: 100%;
        background: url(../../assets/img/login.jpg) no-repeat;
        background-size: 100% 100%;
    }

    .ms-title {
        width: 100%;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
        color: #fff;
        border-bottom: 1px solid #ddd;
    }

    .ms-title > span {
        color: #004370;
        font-weight: bold;
        margin-right: 8px;
    }

    .ms-login {
        width: 380px;
        height: 330px;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.3);
        overflow: hidden;
    }

    .ms-content {
        padding: 30px 30px;
    }

    .login-btn {
        text-align: center;
    }

    .login-btn button {
        width: 100%;
        height: 36px;
        margin-bottom: 10px;
    }

    .checking {
        position: relative;
    }

    .canvas {
        display: inline-block;
        height: 40px;
        position: absolute;
        bottom: 0;
        right: 0;
        cursor: pointer;
        background-color: #fff;
        border-radius: 5px;
    }

</style>
